module.exports = __webpack_public_path__ + "static/img/ui_spacer_black_wide.3f714f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AbouttheSavior/ui_spacer_black_wide.png
// module id = EUZq
// module chunks = 1